import { render, staticRenderFns } from "./creaPdfAcuerdoV2.vue?vue&type=template&id=585fab9e&scoped=true"
import script from "./creaPdfAcuerdoV2.vue?vue&type=script&lang=js"
export * from "./creaPdfAcuerdoV2.vue?vue&type=script&lang=js"
import style0 from "./creaPdfAcuerdoV2.vue?vue&type=style&index=0&id=585fab9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585fab9e",
  null
  
)

export default component.exports